import { useEffect, useState } from 'react';
import { db } from '../../ReactNative/firebase';
import {
    Text,
    Platform,
    SafeAreaView,
    View,
    FlatList,
    useColorScheme,
} from 'react-native';
import { onValue, ref } from 'firebase/database';

const PrimScoreboard = () => {
    const isDarkMode = useColorScheme() === 'dark';

    const [dataHere, setData] = useState<
        Array<{ name: string; score: number; time: string }>
    >([]);

    useEffect(() => {
        const dbRef = ref(db, 'PrimTriviaScoreboard/');

        const unsubscribe = onValue(dbRef, (snap) => {
            const data = snap.val();

            if (!data) {
                setData([]);
                return;
            }

            // Convert Firebase object → array
            const array = Object.values(data) as Array<{
                name: string;
                score: number;
                time: string;
            }>;

            const sorted = array.sort((a, b) => b.score - a.score);

            setData(sorted);
        });

        return () => unsubscribe();
    }, []);

    return (
        <SafeAreaView
            style={{
                flex: 1,
                backgroundColor: isDarkMode ? 'black' : 'white',
            }}
        >
            {/* HEADER */}
            <View
                style={{
                    paddingVertical: 20,
                    alignItems: 'center',
                }}
            >
                <Text
                    style={{
                        color: isDarkMode ? 'white' : 'black',
                        fontSize: 42,
                        textAlign: 'center',
                        fontFamily:
                            Platform.OS === 'android'
                                ? 'serif'
                                : 'Noteworthy-bold',
                    }}
                >
                    Prim's 7th Scoreboard
                </Text>
            </View>

            {/* TABLE */}
            <View
                style={{
                    flex: 1,
                    margin: 10,
                    borderRadius: 20,
                    borderWidth: 2,
                    borderColor: 'powderblue',
                    overflow: 'hidden',
                }}
            >
                {/* HEADER ROW */}
                <View
                    style={{
                        flexDirection: 'row',
                        paddingVertical: 10,
                        backgroundColor: 'rgba(0,0,0,0.05)',
                    }}
                >
                    <Text
                        style={{
                            flex: 2,
                            textAlign: 'center',
                            fontSize: 22,
                            fontWeight: 'bold',
                            color: isDarkMode ? 'white' : 'black',
                        }}
                    >
                        Name
                    </Text>

                    <Text
                        style={{
                            flex: 1,
                            textAlign: 'center',
                            fontSize: 22,
                            fontWeight: 'bold',
                            color: isDarkMode ? 'white' : 'black',
                        }}
                    >
                        Score
                    </Text>

                    <Text
                        style={{
                            flex: 1,
                            textAlign: 'center',
                            fontSize: 22,
                            fontWeight: 'bold',
                            color: isDarkMode ? 'white' : 'black',
                        }}
                    >
                        Time
                    </Text>
                </View>

                {/* LIST */}
                <FlatList
                    data={dataHere}
                    keyExtractor={(_, index) => index.toString()}
                    renderItem={({ item }) => (
                        <View
                            style={{
                                flexDirection: 'row',
                                paddingVertical: 10,
                            }}
                        >
                            <Text
                                style={{
                                    flex: 2,
                                    textAlign: 'center',
                                    fontSize: 18,
                                    color: isDarkMode ? 'white' : 'black',
                                }}
                            >
                                {item.name}
                            </Text>

                            <Text
                                style={{
                                    flex: 1,
                                    textAlign: 'center',
                                    fontSize: 18,
                                    color: isDarkMode ? 'white' : 'black',
                                }}
                            >
                                {item.score}
                            </Text>

                            <Text
                                style={{
                                    flex: 1,
                                    textAlign: 'center',
                                    fontSize: 18,
                                    color: isDarkMode ? 'white' : 'black',
                                }}
                            >
                                {item.time}s
                            </Text>
                        </View>
                    )}
                />
            </View>
        </SafeAreaView>
    );
};

export default PrimScoreboard;